import React, { useState } from 'react';
import {
  Checkbox,
  Collapse,
  Fade,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { ProcessProductModel } from 'types/models';
import { MoneyMask } from 'utils/masks';
import { UITextField } from 'shared/components/Inputs';

interface ProcessOrderRowProps {
  processProduct: ProcessProductModel;
  onChange: (row: ProcessProductModel) => void;
  isSelected: boolean;
  hasError: boolean;
  onChangeQuantity: (id: number, quantity: number) => void;
  valueRow: number;
  onChangeObservation: (id: number, observation: string) => void;
}

// TABLE HEADER:
//  - Item
//  - SKU
//  - Produto
//  - Valor NF Nestlé (R$) (UNI)
//  - Valor Instituição (R$) (UNI)
//  - Valor total do item (R$)
//  - Faturado (R$)
//  - Saldo do item (UNI)
//  - Quantidade (UNI)

export function ProcessOrderCreateRow({
  processProduct,
  onChange,
  isSelected,
  onChangeQuantity,
  hasError,
  valueRow,
  onChangeObservation
}: ProcessOrderRowProps) {
  const [open, setOpen] = useState(false);

  const handleOpenRow = () => {
    setOpen(!open);
  };

  const handleSelect = () => {
    onChange(processProduct);
  };

  const handleChangeInput = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    event.preventDefault();
    const { value } = event.target;
    onChangeQuantity(Number(processProduct.id), Number(value));
  };

  const handleChangeObservation = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    event.preventDefault();
    const { value } = event.target;
    if (value) {
      onChangeObservation(Number(processProduct.id), value);
    }
  };

  return (
    <>
      <TableRow style={{ backgroundColor: isSelected ? 'white' : '#f3f3f3' }}>
        <TableCell padding="checkbox">
          <Checkbox
            onChange={handleSelect}
            color={'primary'}
            checked={isSelected}
            defaultValue={String(isSelected)}
            inputProps={{ 'aria-label': 'select all desserts' }}
          />
        </TableCell>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={handleOpenRow}
          >
            <KeyboardArrowDownIcon />
          </IconButton>
        </TableCell>
        <TableCell align={'center'}>{processProduct?.itemNumber}</TableCell>
        <TableCell align={'center'}>{processProduct?.product?.sku}</TableCell>
        <TableCell align={'center'}>
          {processProduct?.product?.description}
        </TableCell>
        <TableCell align={'center'}>
          {MoneyMask(String(processProduct?.nfPrice || ''))}
        </TableCell>
        <TableCell align={'center'}>
          {MoneyMask(String(processProduct?.institutionValue || ''))}
        </TableCell>
        <TableCell align={'center'}>
          {(processProduct?.quantity || 0) *
            (processProduct?.institutionValue || 0)}
        </TableCell>
        <TableCell align={'center'}>{processProduct?.quantity}</TableCell>
        <TableCell align={'center'}>
          <Fade in={isSelected}>
            <UITextField
              name={'quantity'}
              label={'Quantidade'}
              disabled={!isSelected}
              type={'number'}
              onChange={handleChangeInput}
              error={hasError}
              helperText={
                hasError && 'Coloque uma quantidade menor ou igual ao saldo'
              }
              value={valueRow || 0}
            />
          </Fade>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
          <Collapse in={open}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell width={'40%'}> Descritivo</TableCell>
                  <TableCell width={'60%'}> Observações </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>{processProduct?.specification}</TableCell>
                  <TableCell>
                    <UITextField
                      name={'observation'}
                      label={
                        'Observações (Ex: Local de entrega, validade dos produtos etc)'
                      }
                      placeholder={
                        'Ex. Local de entrega, validade dos produtos etc.'
                      }
                      multiline
                      minRows={4}
                      disabled={!isSelected}
                      onChange={handleChangeObservation}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}
